import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { RulesRepository } from '@core/repositories/rules.repository';
import { Rule } from '@shared/interfaces/rule';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiRulesRepository implements RulesRepository {
  public url = this.appConfig.URL + '/amlcontrol/v1/rules/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  add(rule: Rule): Observable<any> {
    const data = {
      data: {
        id: rule.id,
        type: 'Rule',
        attributes: {
          name: rule.name
        }
      }
    };
    return this.http.post(this.url, data);
  }

  edit(rule: Rule): Observable<any> {
    const data = {
      data: {
        id: rule.id,
        type: 'Rule',
        attributes: {
          name: rule.name
        }
      }
    };
    return this.http.put(this.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(this.url + item);
  }
}
